import TicketCard from '../components/TicketCard'
import { useEffect, useContext } from 'react'
import axios from 'axios'
import CategoriesContext from '../context'

const Dashboard = ({tickets,setTickets}) => {
  const baseURL = process.env.REACT_APP_BASE_URL || 'http://localhost:8000/tickets'

  const { setCategories } = useContext(CategoriesContext)

  useEffect(()=>{
    async function fetchData() {
      try {
            const response = await axios.get(baseURL)
    const dataObject = response.data.data
    const arrayOfKeys = Object.keys(dataObject)
    const arrayOfData = Object.values(dataObject)
    const formattedArray = []
    arrayOfKeys.forEach((key, index) => {
      const formmatedData = { ...arrayOfData[index] }
      formmatedData['documentId'] = key
      formattedArray.push(formmatedData)
    })
    setTickets(formattedArray)
      } catch (error) {
        console.log('Server probably out of reach', error.messages);        
      }
  }
  fetchData();
  }, [])

  useEffect(() => {
    setCategories([...new Set(tickets?.map(({ category }) => category))])
  }, [tickets])

  const colors = [
    '#f5c7f7',
    '#a393eb',
    '#5e63b6',
    '#27296d',
  ]

  const uniqueCategories = [
    ...new Set(tickets?.map(({ category }) => category)),
  ]

  return (
    <div className="dashboard">
      <h1>Tickets</h1>
      <div className="ticket-container">
        {tickets &&
          uniqueCategories?.map((uniqueCategory, categoryIndex) => (
            <div key={+categoryIndex+1*Math.random()}>
              <h3>{uniqueCategory}</h3>
              {tickets
                .filter((ticket) => ticket.category === uniqueCategory)
                .map((filteredTicket, _index) => (
                  <TicketCard setTickets={setTickets}
                  key={+categoryIndex+1*Math.random()}
                    id={_index}
                    color={colors[categoryIndex] || colors[0]}
                    ticket={filteredTicket}
                  />
                ))}
            </div>
          ))}
      </div>
    </div>
  )
}

export default Dashboard
